

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { TemplateInstanceFormComponent } from './templateinstance-form/templateinstance-form.component';
import { TemplateInstanceComponent } from './templateinstance.component';
import { TemplateInstanceRoutes } from './templateinstance.routing';

export function declaration() {
    return [TemplateInstanceComponent, TemplateInstanceFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class TemplateInstanceModule {
}

@NgModule({
    imports: [TemplateInstanceModule, TemplateInstanceRoutes],
    exports: [TemplateInstanceModule]
})
export class TemplateInstanceWithRouteModule {
}
